import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      isLoggedIn:false,
      isTokenAccess:false,
      emailVerified:false,
      tokensLeft:0,
  },
  mutations: {
    isLoggedIn: (state, value) =>
    {state.isLoggedIn = value},
    isTokenAccess: (state, value) =>
    {state.isTokenAccess = value},
    emailVerified: (state, value) =>
    {state.emailVerified = value},
    tokensLeft: (state, value) =>
    {state.tokensLeft = value},
    initializeStore(state){
        if (sessionStorage.getItem('authToken')) {
            state.isLoggedIn = true;
        }
        if (sessionStorage.getItem('accessToken') && !sessionStorage.getItem('authToken')) {
            state.isTokenAccess = true;
        }
    },
  },
  actions: {
        fetchTokens({ commit }, schoolId) {
            return axios.get(process.env.VUE_APP_BASEURL+`/tkleft?school_id=${schoolId}`, {
            headers: { Authorization: `Bearer ${sessionStorage.getItem('authToken')}` }
            }).then(res => {
            commit('tokensLeft', res.data.tokens_left);
            }).catch(() => {});
        },
        updateTokens({ commit }, value) {
            commit('tokensLeft', value)
        }
  },
  modules: {
  }
})
